import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getIncidentsMyWorksToAdministrateIncidents: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.INCIDENTS_MY_WORKS_TO_ADMINISTRATE_INCIDENTS].GET_INCIDENTS_MY_WORKS_TO_ADMINISTRATE_INCIDENTS,
	},

}
